import { Button } from '@chakra-ui/react';
import {
  Box,
  Container,
  Grid,
  Heading,
  Link,
  Text,
} from '@joinrepublic/dls-ui-kit';

import { colors, containerSize } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';
import { MotionBoxGroup } from '../motion-box-group/motion-box-group';
import appBgX1 from './assets/bg-app@1x.jpg';
import appBgX2 from './assets/bg-app@2x.jpg';
import { FEATURES } from './data';
import { IFeatureItem } from './types';

export const CreateWallet = () => {
  return (
    <Box
      as="section"
      id="create-wallet"
      py={{ base: '0', sm: '12' }}
      backgroundImage={`image-set(
        url(${appBgX1}) 1x,
        url(${appBgX2}) 2x
      )`}
      bgRepeat="no-repeat"
      bgPosition={{
        base: 'calc(50% + 65px) calc(100% + 1px)',
        sm: 'calc(50% + 500px) 100%',
      }}
      bgSize={{ base: '450px auto', sm: '876px auto' }}
    >
      <Container maxW={containerSize}>
        <Box
          position="relative"
          pt="12"
          px={{ base: '0', sm: '12', lg: '20' }}
          pb={{ base: '430px', sm: '12' }}
        >
          <Box w={{ base: 'auto', sm: '52%' }}>
            <MotionBoxGroup>
              <MotionBox as="header">
                <Heading
                  mt="0"
                  maxW="520px"
                  size="title-md"
                  color={colors.darkNavyTypography}
                >
                  The easiest way to secure, send, and hold digital assets
                </Heading>
              </MotionBox>

              <Grid
                templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)' }}
                rowGap={{ base: '5', sm: '6' }}
                columnGap="9%"
                mt={{ base: '6', sm: '12' }}
                sx={{
                  textWrap: 'pretty',
                }}
              >
                {FEATURES.map(
                  ({ icon, title, description }: IFeatureItem, index) => (
                    <MotionBox key={index} delay={index * 0.07 + 0.15}>
                      <Box mb={{ base: '2', sm: '4' }}>{icon}</Box>
                      <Text
                        as="h3"
                        size="body-md"
                        color={colors.darkNavyTypography}
                      >
                        {title}
                      </Text>
                      <Text
                        size={{ base: 'body-sm' }}
                        textStyle={{ xs: 'body-sm-md' }}
                        variant="text-secondary"
                        mt={{ base: '1', sm: '2' }}
                      >
                        {description}
                      </Text>
                    </MotionBox>
                  )
                )}
              </Grid>

              <MotionBox
                delay={0.35}
                mt={{ base: '16', sm: '12' }}
                mx={{ base: 'auto', sm: '0' }}
                w="full"
                maxW="64"
              >
                <Button
                  as="a"
                  href="/crypto/create-wallet"
                  variant="republic-primary"
                  size="md"
                  py="6"
                  w="full"
                  bgColor="#3C2E5D"
                  _hover={{ bgColor: '#5D4C84' }}
                >
                  Create a wallet
                </Button>

                <Box mt="2" textAlign="center">
                  <Link
                    href="/wallet"
                    size="body-sm"
                    textStyle={{ sm: 'body-sm-md' }}
                    _hover={{ textDecoration: 'none' }}
                  >
                    Learn more
                  </Link>
                </Box>
              </MotionBox>
            </MotionBoxGroup>
          </Box>

          <Box
            position="absolute"
            inset="0"
            top={{ base: 'auto', sm: '0' }}
            bottom={{ base: '16', sm: '0' }}
            h={{ base: '300px', sm: 'auto' }}
            pointerEvents="none"
            border="2px solid"
            borderColor="rgba(6 18 49 / 0.2)"
            borderRadius="lg"
            sx={{
              '--_side': { base: '28px', sm: '40px' },
              mask: `linear-gradient(black), linear-gradient(black)`,
              maskSize: 'calc(var(--_side) * 2)',
              maskPosition: 'left, right',
              maskRepeat: 'no-repeat',
            }}
          ></Box>
        </Box>
      </Container>
    </Box>
  );
};
